/** @flow */

export const EMPLOYEE_QUESTION_TYPE = {
  STANDARD: "STANDARD",
  DINAMYC: "DINAMIC",
};

export const MEDICAL = "MEDICAL";

export const RTW_INTERVIEW_STATUSES = {
  EXPIRED: "EXPIRED",
  COMPLETED_LATE: "COMPLETED_LATE",
  COMPLIANT: "COMPLIANT",
  OVERDUE: "OVERDUE",
  OUTSTANDING: "OUTSTANDING",
  CANCELLED: "CANCELLED",
};
